import { CreateButton, EditButton, FunctionField, ShowButton, TextField, TopToolbar, WrapperField } from 'react-admin';

import CraftList from 'src/components/CraftList';
import AuditBasedStatusFilterInput from 'src/inputs/AuditBasedStatusFilterInput';
import ClearFiltersButton from 'src/components/ClearFiltersButton';
import BulkSoftDeleteButton from 'src/components/BulkSoftDeleteButton';
import { usePermissions } from 'src/hooks';
import { CriterionRecord } from 'src/types';

const columnStyles = {
  actions: {
    width: '12rem',
    '& :nth-child(n + 2)': {
      ml: 0.5,
    },
  },
};

const filters = [
  <AuditBasedStatusFilterInput key="statusFilter" source="archived_at@_is_null" inactiveLabel="Archived" alwaysOn />,
];

const ListActions = ({ canCreate }: { canCreate: boolean }) => (
  <TopToolbar>
    <ClearFiltersButton />
    {canCreate && <CreateButton />}
  </TopToolbar>
);

export const CriteriaList = () => {
  const { permissions } = usePermissions();

  const canCreate = permissions.has('criteria:edit');
  const canEdit = permissions.has('criteria:edit');
  const canDelete = permissions.has('criteria:delete');

  const bulkActionButtons = canDelete && (
    <BulkSoftDeleteButton
      label="Delete Selected"
      dialogTitle="Delete Risk Signals (%{smart_count})"
      dialogContent="Are you sure you want to delete these items?"
      data={{ archived_at: 'now()' }}
    />
  );

  return (
    <CraftList
      title="Risk Signals"
      filters={filters}
      filterDefaultValues={{ 'archived_at@_is_null': true }}
      actions={<ListActions canCreate={canCreate} />}
      showClearButton={false}
      sort={{ field: 'name', order: 'ASC' }}
      dataGridProps={{ bulkActionButtons }}
      columnStyles={columnStyles}
    >
      <TextField source="name" />
      <TextField source="description" />
      <WrapperField label="Actions" headerClassName="column-actions" cellClassName="column-actions">
        <ShowButton />
        {canEdit && <FunctionField render={(rec: CriterionRecord) => <EditButton disabled={!!rec.archived_at} />} />}
      </WrapperField>
    </CraftList>
  );
};

export default CriteriaList;
